export default __webpack_public_path__ + "static/media/404.8e14f1b2.png";